import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const requiredSkillDefinition: ResourceDefinition = {
  title: 'Required Skills',
  nameSingular: 'Required Skill',
  namePlural: 'Required Skills',
  className: 'RequiredSkill',
  mainIdentifier: 'name',
  slug: 'taxonomies/required-skills',
  path: 'required-skills',
  icon: 'icon-grid',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editTaxonomies',
      action: (requiredSkill) => ({
        type: ActionType.Link,
        link: {
          path: `${requiredSkillDefinition.path}/${requiredSkill.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteTaxonomies',
      action: (requiredSkill) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: requiredSkill,
          definition: requiredSkillDefinition
        }
      })
    }
  ]
}
